import { render, staticRenderFns } from "./ChengJiaoGongGao.vue?vue&type=template&id=d8538246&scoped=true"
import script from "./ChengJiaoGongGao.vue?vue&type=script&lang=js"
export * from "./ChengJiaoGongGao.vue?vue&type=script&lang=js"
import style0 from "./ChengJiaoGongGao.vue?vue&type=style&index=0&id=d8538246&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8538246",
  null
  
)

export default component.exports